export interface AICriteriaCategoryOptions {
  name?: string;
  color?: string;
  order?: number;
}

export class AICriteriaCategory {
  name: string;
  color: string;
  order: number;

  constructor(options?: AICriteriaCategoryOptions) {
    this.name = options?.name ?? '';
    this.color = options?.color ?? '';
    this.order = options?.order ?? 0;
  }
}

export interface AICriteriaOptions {
  id?: string;
  criterion?: string;
  description?: string;
  category?: string;
  archived?: boolean;
  order?: number;
}

export class AICriteria {
  id: string;
  criterion: string;
  description: string;
  category: string;
  archived: boolean;
  order: number;

  constructor(options?: AICriteriaOptions) {
    this.id = options?.id ?? '';
    this.criterion = options?.criterion ?? '';
    this.description = options?.description ?? '';
    this.category = options?.category ?? '';
    this.archived = options?.archived ?? false;
    this.order = options?.order ?? 0;
  }
}
